import React from 'react';
import { FlexMiddle } from '../../Flex';

const ExternalOptionsChip = ({ slug, value, externalOptions = {} }) => {
  const selected = value ? (Array.isArray(value) ? value : [value]) : [];

  return (
    <FlexMiddle>
      {(externalOptions[slug] || [])
        .filter(({ id }) => selected.includes(id))
        .map(({ value: optionValue }) => optionValue)
        .join(', ')}
    </FlexMiddle>
  );
};

export default ExternalOptionsChip;
